export const HERO_IMAGE = "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&w=940";

export const LINKS = {
  linkedin: "https://www.linkedin.com/in/ji-kim-5179495",
  github: "https://github.com/jhk505k",
  email: "jhk505ko@gmail.com",
  phone: "(706) 304-1620",
  location: "Columbus, GA",
  resume: "/Gabe_Kim_Resume.pdf",
};

export const SUMMARY =
  "Results-driven Full Stack Java Developer with 8+ years of experience designing, developing, and modernizing enterprise software across telecommunications, healthcare, IoT, AI, blockchain, and cloud environments. Proven ability to modernize legacy systems, build scalable cloud-native applications, automate deployments, and deliver reliable software in Agile environments.";

export const MARQUEE_ITEMS = [
  "Java 17", "Spring Boot", "Microservices", "AWS", "React", "Distributed Systems",
  "Python", "Kafka", "Docker", "Kubernetes", "PostgreSQL", "CI/CD", "gRPC", "TensorFlow",
];

export const SKILLS = [
  { category: "Backend", items: ["Java", "Spring Boot", "Hibernate JPA", "MyBatis", "Python (Django & Spark)", "C / C++"] },
  { category: "Frontend", items: ["React", "Angular (TypeScript)", "JSP", "JavaScript", "jQuery"] },
  { category: "Databases", items: ["MySQL / MariaDB", "PostgreSQL", "Oracle DB", "MS-SQL", "MongoDB", "Redis"] },
  { category: "DevOps & Cloud", items: ["AWS EC2", "AWS RDS", "AWS S3", "AWS Route53", "AWS CloudFront", "AWS Lambda", "AWS EKS & ECS", "AWS Load Balancer", "Docker", "Kubernetes + ArgoCD", "Jenkins", "GitHub Actions"] },
  { category: "Data Engineering", items: ["Kafka", "Hadoop", "Spark", "Hive", "Apache Nifi", "Streamsets"] },
  { category: "Infrastructure", items: ["Tomcat", "Oracle WebLogic", "Cisco Networks (CCNP)", "VMware Harbor", "Linux"] },
];

export const EXPERIENCE = [
  {
    period: "2023 — 2024",
    role: "Java Software Developer",
    company: "Compax Digital",
    type: "Contract",
    location: "Seoul, South Korea",
    bullets: [
      "Integrated enterprise BSS platforms with LG U+ Nerget and StarHub telecommunication systems using Java Spring (JSF & Hibernate JPA) and PostgreSQL.",
      "Managed AWS cloud infrastructure including EC2, RDS, VPC, Route 53, and EKS Kubernetes clusters (GitHub Actions & ArgoCD) supporting production applications.",
      "Configured and maintained Cisco ISR routers, Catalyst switches, and ASA firewalls.",
      "Collaborated with cross-functional teams to deliver enterprise system integrations on schedule.",
    ],
  },
  {
    period: "2023",
    role: "Software Architect",
    company: "CK&B",
    type: "Fixed-term Freelance",
    location: "Seoul, South Korea",
    bullets: [
      "Designed backend architecture for the HiddenTag Global platform serving authentication, community, review, and marketplace services.",
      "Developed RESTful APIs and database architecture using Spring Boot, Hibernate JPA, MyBatis, and MySQL.",
      "Migrated application deployment from traditional Tomcat servers to Docker-based containerized infrastructure on AWS.",
      "Successfully supported the production launch of the HiddenTag Global platform.",
    ],
  },
  {
    period: "2022 — 2023",
    role: "Application Architect",
    company: "LG CNS",
    type: "Contract",
    location: "Seoul, South Korea",
    bullets: [
      "Modernized the SEHATI Bahrain National Health Insurance System on AWS: JDK 7 → 8, Tomcat 7 → 9, Oracle RDS 12c → 19c.",
      "Built CI/CD pipelines and automated deployments in a GitOps / ArgoCD Kubernetes system for the Next Generation GS Postbox system.",
      "Automated deployments with Jenkins for the LG U+ Digital Catalog system on the Adobe AEM framework via custom Maven profiles.",
      "Managed and deployed interface services (MCI / FEP / EAI service mesh) for Shinhan Bank's The Next Project.",
      "Developed Java Batch services in MyBatis for the next-generation Korean social security information system.",
    ],
  },
  {
    period: "2021 — 2022",
    role: "Software Developer",
    company: "BFLabs",
    type: "Contract",
    location: "Seoul, South Korea",
    bullets: [
      "Developed an integrated REST API gateway server in Java Spring for the Middleblock blockchain platform (Hyperledger Indy, Aries & Fabric).",
      "Designed and implemented the big data warehouse infrastructure and monitoring platform for the Yeosu Data Flagship project using Hadoop, Spark, Hive, Django, and React.",
    ],
  },
  {
    period: "2020 — 2021",
    role: "Software Developer",
    company: "SIOT InfoTech",
    type: "Contract",
    location: "Seoul, South Korea",
    bullets: [
      "Migrated the main Sensor Gateway backend from Go to Java Spring (TCP/IP socket, gRPC, REST API) and implemented Kafka-based data pipelines.",
      "Upgraded Kafka pipelines with Apache Nifi and Streamsets; built the Goseong & Sacheon tourist sensor IoT dashboard (React, Java Spring, MariaDB).",
      "Managed Docker-based AWS production environments supporting multiple customer applications.",
    ],
  },
  {
    period: "2018 — 2019",
    role: "AI Software Developer",
    company: "MICUBE Solution",
    type: "Contract",
    location: "Seoul, South Korea",
    bullets: [
      "Developed the MICUBE AI Visualization Tool dashboard for a KISA government project using Java Spring, Angular, and Python.",
      "Built predictive equipment maintenance applications for Daeduk Electronics with a TensorFlow RMSE model on vibration sensor data.",
      "Developed a computer-vision rock detection application for Hyundai Chungju Biocenter using TensorFlow Mask R-CNN.",
      "Managed Hadoop, Kafka, Ambari, and Linux server infrastructure.",
    ],
  },
];

export const PROJECTS = [
  {
    id: "nerget-integration",
    title: "LG U+ Nerget BSS Integration",
    company: "Compax Digital",
    category: "Telecom BSS",
    image: "/projects/nerget-logo.webp",
    link: "https://www.lguplus.com/nerget/main?p=3",
    description: "Integrated Compax Digital's enterprise BSS platform with LG U+'s Nerget system — handling subscriber management, billing and service provisioning flows between the two platforms using Java Spring (JSF & Hibernate JPA) and PostgreSQL.",
    tech: ["Java Spring", "JSF", "Hibernate JPA", "PostgreSQL", "BSS"],
    challenge: "LG U+'s Nerget platform and Compax's enterprise BSS each managed subscriber and billing data independently, requiring a robust integration layer to keep accounts, services and invoices synchronized without manual reconciliation.",
    approach: "Built the integration layer in Java Spring with JSF front-end screens and a Hibernate JPA persistence layer over PostgreSQL, mapping Nerget's data models onto Compax's BSS entities and validating end-to-end subscriber, billing and provisioning flows in LG U+'s staging environment.",
    outcome: "The integration went live connecting Compax's BSS with Nerget, enabling automated data flow for subscriber management and billing across both platforms.",
  },
  {
    id: "starhub-integration",
    title: "StarHub BSS Integration",
    company: "Compax Digital",
    category: "Telecom BSS",
    image: "/projects/starhub-logo.webp",
    link: "https://www.starhub.com/personal.html",
    description: "Integrated Compax Digital's enterprise BSS platform with StarHub's telecommunication systems in Singapore, delivering subscriber, billing and service management flows using Java Spring (JSF & Hibernate JPA) and PostgreSQL.",
    tech: ["Java Spring", "JSF", "Hibernate JPA", "PostgreSQL", "BSS"],
    challenge: "StarHub, Singapore's major telco, needed Compax's BSS platform to interoperate with its internal telecommunication systems across subscriber onboarding, billing cycles and service provisioning — with strict data consistency requirements.",
    approach: "Developed the integration services in Java Spring with a JSF interface layer and Hibernate JPA over PostgreSQL, coordinating closely with StarHub's engineering teams through joint testing cycles to certify each integration flow.",
    outcome: "Successfully delivered the StarHub integration on schedule, extending Compax's BSS footprint into the Southeast Asian telecom market.",
  },
  {
    id: "hiddentag",
    title: "HiddenTag Global Platform",
    company: "CK&B",
    category: "Blockchain & Security",
    image: "/projects/hiddentag.webp",
    link: "https://www.hiddentag.com/nation/usa/main.jsp",
    description: "Designed backend architecture for a global authentication, community, review, and marketplace platform. Built RESTful APIs and the database layer, then migrated deployment from Tomcat to Docker-based containers on AWS for the production launch.",
    tech: ["Spring Boot", "Hibernate JPA", "MyBatis", "MySQL", "Docker", "AWS"],
    challenge: "HiddenTag needed a single global backend serving four distinct product domains — authentication, community, reviews and marketplace — while running on legacy Tomcat infrastructure that made releases slow and risky.",
    approach: "Designed the backend architecture from scratch with Spring Boot, separating domain services and exposing clean RESTful APIs. Built the data layer with Hibernate JPA and MyBatis over MySQL, then containerized the entire deployment with Docker on AWS to replace the Tomcat servers.",
    outcome: "The HiddenTag Global platform launched to production on schedule, with a containerized deployment pipeline that made subsequent releases faster and rollback-safe.",
  },
  {
    id: "sehati-bahrain",
    title: "SEHATI — Bahrain National Health Insurance System",
    company: "LG CNS",
    category: "National Healthcare",
    image: "/certs/sehati-hero.webp",
    link: "https://www.sehati.gov.bh/",
    description: "Modernized the SEHATI Bahrain National Health Insurance System on AWS — upgrading JDK 7 → 8, Tomcat 7 → 9, and Oracle RDS 12c → 19c for the Kingdom of Bahrain's national health insurance platform.",
    tech: ["Java", "AWS", "Tomcat", "Oracle RDS"],
    challenge: "Bahrain's national health insurance system was running on aging infrastructure — JDK 7, Tomcat 7 and Oracle 12c — accumulating security vulnerabilities and maintenance risk for a platform serving the entire country. The urgency escalated when AWS announced a forced upgrade of all older Oracle database versions to newer releases: our LG CNS manager recognized that an unmanaged, AWS-imposed database upgrade could break compatibility with the production system and cause a national outage. On top of the database risk, the legacy stack carried known security vulnerabilities that needed addressing.",
    approach: "Rather than let AWS force the Oracle upgrade on its own schedule, we took control: planned and executed a staged migration of Oracle RDS 12c → 19c with full compatibility testing against production workloads, and upgraded the runtime from JDK 7 to 8 and the application server from Tomcat 7 to 9 in the same program. A JavaScript-to-jQuery frontend modernization was scoped but deliberately deferred — it required more development time and planning, and the Oracle database was the critical issue driving the timeline.",
    outcome: "SEHATI migrated to Oracle 19c, JDK 8 and Tomcat 9 on AWS ahead of AWS's forced upgrade — with zero production outage. The national health insurance system now runs on supported, secure versions of its core stack, with the frontend modernization properly planned as a separate follow-up project.",
  },
  {
    id: "gspostbox",
    title: "Next Generation GS Postbox System",
    company: "LG CNS",
    category: "Logistics & Cloud",
    image: "/projects/gs-postbox.webp",
    link: "https://www.gspostbox.com/main/index.do",
    description: "Developed the CI/CD pipeline and automated deployments in a GitOps / ArgoCD Kubernetes system for the next-generation GS Postbox platform.",
    tech: ["GitOps", "ArgoCD", "Kubernetes"],
    challenge: "The next-generation GS Postbox system needed frequent, reliable releases across environments, but deployments were manual, error-prone and hard to audit.",
    approach: "Designed a GitOps-based CI/CD pipeline on Kubernetes with ArgoCD, making Git the single source of truth for every environment and automating rollout from commit to cluster.",
    outcome: "Deployments became fully automated and auditable, with declarative rollbacks and consistent environments across the delivery pipeline.",
  },
  {
    id: "lguplus",
    title: "LG U+ Digital Catalog System",
    company: "LG CNS",
    category: "Telecom Systems",
    image: "/projects/lgu-logo.webp",
    link: "https://www.lguplus.com/",
    description: "Built CI/CD pipelines and automated deployments using Jenkins for the LG U+ digital catalog system on the Adobe AEM framework, via custom Maven profiles.",
    tech: ["Jenkins", "Adobe AEM", "Maven"],
    challenge: "The LG U+ digital catalog ran on Adobe AEM, where releases involved many manual packaging steps that slowed down telecom product updates.",
    approach: "Built Jenkins-based CI/CD pipelines and engineered custom Maven profiles tailored to the AEM framework, automating build, packaging and deployment for each environment.",
    outcome: "Catalog releases were automated end to end, cutting deployment effort and letting content and product updates reach production faster.",
  },
  {
    id: "shinhanbank",
    title: "Shinhan Bank — The Next Project",
    company: "LG CNS",
    category: "Core Banking",
    image: "/projects/shinhan-logo.webp",
    link: "https://www.shinhan.com/en/index.jsp",
    description: "Managed and deployed interface services (MCI / FEP / EAI service mesh) for Shinhan Bank's next-generation internal management system.",
    tech: ["MCI", "FEP", "EAI Service Mesh"],
    challenge: "Shinhan Bank's next-generation internal system depended on a web of inter-system interfaces (MCI / FEP / EAI) where any misconfiguration could disrupt core banking operations.",
    approach: "Managed and deployed the interface service mesh across environments, coordinating releases and validating message flows between the bank's internal systems.",
    outcome: "Interface services were deployed and operated stably throughout the project, keeping mission-critical internal banking systems connected.",
  },
  {
    id: "korean-social-security",
    title: "Korean Social Security Information System",
    company: "LG CNS",
    category: "Public Sector",
    image: "/projects/ssis.webp",
    link: "https://ssis.or.kr/index.do",
    description: "Developed Java Batch services in MyBatis for the next-generation Korean social security information system.",
    tech: ["Java Batch", "MyBatis"],
    challenge: "The national social security system processes enormous volumes of welfare and eligibility data in scheduled batch windows with zero tolerance for failure.",
    approach: "Developed Java Batch services with MyBatis, structuring jobs for restartability and precise data mapping against the system's large relational schemas.",
    outcome: "Batch services were delivered for the next-generation system, processing nationwide social security data reliably within the required windows.",
  },
  {
    id: "middleblock",
    title: "Middleblock Blockchain Platform",
    company: "BFLabs",
    category: "Blockchain",
    image: "/projects/bflabs.webp",
    link: "http://www.bflabs.co.kr/",
    linkLabel: "About BFLabs",
    description: "Developed an integrated REST API gateway server in Java Spring for the Middleblock blockchain platform (Hyperledger Indy, Aries & Fabric) for easy integration with customer applications.",
    tech: ["Java Spring", "Hyperledger Indy", "Hyperledger Aries", "Hyperledger Fabric"],
    challenge: "The Middleblock platform (Hyperledger Indy, Aries & Fabric) was powerful but hard for customer applications to integrate with directly, due to complex blockchain APIs.",
    approach: "Designed and developed an integrated REST API gateway in Java Spring that wrapped the three Hyperledger frameworks behind a single, simple HTTP interface.",
    outcome: "Customer applications could onboard onto the blockchain platform through familiar REST calls, dramatically reducing integration effort.",
  },
  {
    id: "yeosu-flagship",
    title: "Yeosu Data Flagship Project",
    company: "BFLabs",
    category: "Big Data & Smart City",
    image: "/projects/bflabs.webp",
    link: "http://www.bflabs.co.kr/",
    linkLabel: "About BFLabs",
    description: "Designed and implemented the big data warehouse infrastructure and monitoring platform, collaborating with the McKinley Rice international engineering team.",
    tech: ["Hadoop", "Spark", "Hive", "Django", "React"],
    challenge: "The Yeosu Data Flagship project needed to aggregate and analyze city-scale data streams, but there was no warehouse infrastructure or visibility platform to support it.",
    approach: "Designed and implemented a big data warehouse on Hadoop, Spark and Hive, and built a monitoring platform with a Django backend and React frontend, working with the McKinley Rice international engineering team.",
    outcome: "The warehouse and monitoring platform were delivered as the flagship infrastructure for Yeosu's smart city data initiative.",
  },
  {
    id: "sensor-gateway",
    title: "Sensor Gateway Backend Migration",
    company: "SIOT InfoTech",
    category: "IoT Gateway",
    image: "/projects/siot-logo.webp",
    link: "https://www.siotinfotech.com/",
    linkLabel: "About SIOT InfoTech",
    description: "Migrated the main sensor gateway backend from Go to Java Spring (TCP/IP socket, gRPC, REST API) and implemented Kafka-based data pipelines for reliability and scalability.",
    tech: ["Go", "Java Spring", "gRPC", "TCP/IP", "Kafka"],
    challenge: "The core sensor gateway was written in Go, which the organization could not maintain or scale, and sensor data pipelines lacked durability guarantees.",
    approach: "Rewrote the gateway in Java Spring supporting TCP/IP socket, gRPC and REST API ingestion, and implemented Kafka-based pipelines, later upgraded with Apache Nifi and Streamsets for managed data flows.",
    outcome: "The migrated gateway improved data reliability and scalability while aligning the codebase with the team's Java expertise.",
  },
  {
    id: "goseong-sacheon",
    title: "Goseong & Sacheon IoT Dashboard",
    company: "SIOT InfoTech",
    category: "Smart City",
    image: "/projects/siot-logo.webp",
    link: "https://www.siotinfotech.com/",
    linkLabel: "About SIOT InfoTech",
    description: "Developed a tourist sensor IoT dashboard for the Goseong and Sacheon municipalities with real-time telemetry visualization.",
    tech: ["React", "Java Spring", "MariaDB"],
    challenge: "The Goseong and Sacheon municipalities had deployed tourist sensors but had no way to see or act on the data being collected.",
    approach: "Developed a full-stack dashboard with a React frontend, Java Spring backend and MariaDB storage, visualizing live tourist sensor telemetry for city administrators.",
    outcome: "Both municipalities gained a real-time view of tourist flows and sensor health, turning raw IoT data into usable insight.",
  },
  {
    id: "micube-ai",
    title: "MICUBE AI Visualization Tool",
    company: "MICUBE Solution",
    category: "AI Analytics",
    link: "https://www.micube.co.kr/en/micube",
    linkLabel: "About MICUBE Solution",
    image: "/projects/micube-logo.webp",
    description: "Developed an AI visualization dashboard for a KISA government project with real-time analytics and charting.",
    tech: ["Java Spring", "Angular", "Python"],
    challenge: "KISA needed a way to make AI model outputs and security analytics understandable to non-technical government stakeholders.",
    approach: "Developed the AI Visualization Tool dashboard with a Java Spring backend, Angular frontend and Python-based analytics, presenting model results through interactive charts.",
    outcome: "The dashboard was delivered for the KISA government project, giving stakeholders direct visibility into AI-driven analytics.",
  },
  {
    id: "daeduk-pd",
    title: "Daeduk Predictive Maintenance Engine",
    company: "MICUBE Solution",
    category: "Smart Factory & ML",
    image: "/projects/daeduck-logo.webp",
    link: "https://www.daeduck.com/en/main.do",
    linkLabel: "About Daeduck Electronic",
    description: "Built a predictive equipment maintenance platform for Daeduck Electronics: vibration sensors capture machine noise, a Hortonworks big data platform stores and processes it, and a TensorFlow RMSE model detects abnormal vibration — pushing real-time alerts to a factory dashboard.",
    tech: ["Angular", "Java Spring", "TensorFlow", "RMSE Model", "Hortonworks", "Vibration Sensors"],
    challenge: "Daeduck Electronics needed equipment failure predictive analysis on the factory floor — unexpected machine breakdowns were causing unplanned downtime and costly emergency repairs, and there was no early-warning signal that a machine was drifting toward failure.",
    approach: "Vibration sensors were attached to the equipment to continuously collect operating noise, streamed into a Hortonworks big data platform for storage and processing. I built the application in Java Spring with an Angular frontend, training a TensorFlow RMSE model to learn each machine's normal vibration signature and flag any sound deviating from the usual operating mean.",
    outcome: "When vibration deviates from the normal mean, the system flags the abnormality and pushes an alert to the factory dashboard in real time — so floor employees see the warning and can schedule maintenance before a breakdown, shifting Daeduck from reactive repair to predictive maintenance.",
  },
  {
    id: "hyundai-cv",
    title: "Hyundai Computer Vision Rock Detection",
    company: "MICUBE Solution",
    category: "Computer Vision",
    image: "/projects/chungju-biocenter.webp",
    link: "https://www.yna.co.kr/view/AKR20200924056400003",
    linkLabel: "About Chungju Food Waste Bioenergy Center",
    description: "Developed a computer-vision rock detection application for the Chungju Food Waste Bioenergy Center (충주 음식물 바이오에너지센터) — a Hyundai Engineering & Construction facility that converts 80 tons of food waste daily into bio-methane fuel — using a TensorFlow Mask R-CNN model.",
    tech: ["Java Spring", "Angular", "Python", "TensorFlow Mask R-CNN"],
    challenge: "The Chungju Food Waste Bioenergy Center — built by Hyundai Engineering & Construction to turn 80 tons of daily food waste into bio-methane gas for vehicle fuel and city gas — needed automated detection of rocks and debris in processing zones, where manual inspection was slow and inconsistent.",
    approach: "Developed a computer-vision application with Java Spring, Angular and Python, training a TensorFlow Mask R-CNN model for pixel-level segmentation of rocks in camera feeds.",
    outcome: "The system automated rock detection at the biocenter, improving safety and inspection consistency through applied deep learning.",
  },
];

export const EDUCATION = [
  {
    degree: "Master of Science — Electrical & Computer Engineering",
    school: "Georgia Institute of Technology",
    location: "Atlanta, GA",
    detail: "Focus: Telecommunication and Computer Systems / Software",
  },
  {
    degree: "Bachelor of Science — Electrical Engineering",
    school: "Georgia Institute of Technology",
    location: "Atlanta, GA",
    detail: "",
  },
];

export const CERTIFICATIONS = [
  {
    name: "Microsoft Specialist: Programming in C#",
    issuer: "Microsoft",
    id: "701ACF-A13055",
    earned: "May 2015",
    expires: "",
    status: "Active",
    proof: { type: "image", url: "/certs/ms-csharp-certificate.png", label: "View Certificate" },
  },
  {
    name: "Microsoft Certified Solutions Expert: Private Cloud",
    issuer: "Microsoft",
    id: "35KEB5-7386CA",
    earned: "Apr 2013",
    expires: "",
    status: "Inactive",
    proof: { type: "image", url: "/certs/mcse-private-cloud-certificate.png", label: "View Certificate" },
  },
  {
    name: "MCSA: Windows Server 2012 (Charter Member)",
    issuer: "Microsoft",
    id: "D60814-988F4Q",
    earned: "Mar 2013",
    expires: "",
    status: "Inactive",
    proof: { type: "image", url: "/certs/mcsa-windows-server-2012-certificate.png", label: "View Certificate" },
  },
  {
    name: "CCNP Routing and Switching",
    issuer: "Cisco",
    id: "CSCO12143672",
    earned: "Jan 2015",
    expires: "Jan 2018",
    status: "Expired",
    proof: { type: "image", url: "/certs/cisco-certifications.png", label: "View Cisco Transcript" },
  },
  {
    name: "CCNA Routing and Switching",
    issuer: "Cisco",
    id: "CSCO12143672",
    earned: "Feb 2013",
    expires: "Jan 2018",
    status: "Expired",
    proof: { type: "image", url: "/certs/cisco-certifications.png", label: "View Cisco Transcript" },
  },
  {
    name: "CompTIA Security+ ce",
    issuer: "CompTIA",
    id: "COMP001020382835",
    earned: "Sep 2015",
    expires: "Sep 2018",
    status: "Expired",
    proof: { type: "image", url: "/certs/comptia-certifications.png", label: "View CompTIA Transcript" },
  },
  {
    name: "CompTIA Network+ ce",
    issuer: "CompTIA",
    id: "COMP001020382835",
    earned: "Mar 2012",
    expires: "Mar 2015",
    status: "Expired",
    proof: { type: "image", url: "/certs/comptia-certifications.png", label: "View CompTIA Transcript" },
  },
];
